import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';

import { UserService } from '../../../service/user/user.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9005.component.html',
  styleUrls: ['wa9005.component.scss']
})
export class Wa9005Component implements AfterViewInit {
  public componentTitle = 'WA9005:ユーザマスタパスワード変更';

  public logicalWhs: any;
  public roles: any;

  private userId: string;
  public userCd: string;
  public userTx: string;
  public langTx = 'ja';
  public oldPasswordTx: FormControl;
  public newPasswordTx: FormControl;
  public newPasswordTxConf: FormControl;
  public roleId = 2;
  public logicalWhId: number;

  public validation = validation;

  public working = false;
  public height = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  private oldPasswordCls = '';
  private newPasswordCls = '';
  private newPasswordCls2 = '';

  private isSubmitButtonEnabled = false;
  private modal: boolean = false;

  constructor(private router: Router, private userService: UserService, private commonService: CommonService, private dialogsService: DialogsService) {
    const loginresult = sessionStorage.getItem('loginResult');
    this.userId = JSON.parse(loginresult).user.userId;
    this.userCd = JSON.parse(loginresult).user.userCd;

    // 旧パスワード
    this.oldPasswordTx = new FormControl('', [Validators.pattern(validation.password)]);

    // 新パスワード
    this.newPasswordTx = new FormControl('', [Validators.pattern(validation.password)]);

    // 確認パスワード
    this.newPasswordTxConf = new FormControl('', [Validators.pattern(validation.password)]);

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.height = window.innerHeight - 80;
  }

  onResize(event) {
    this.height = event.target.innerHeight - 80;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    if (this.userId === null) {
      this.router.navigate(['wa0001']);
      return;
    }
    const args = 'userId=' + this.userId;
    this.working = true;

    this.userService
      .get(args)
      .then(outputJson => {
        this.working = false;
        // ユーザーコード
        this.userCd = outputJson.users[0].userCd;
        // ユーザ名
        this.userTx = outputJson.users[0].userTx;
        // ロールID
        this.roleId = outputJson.users[0].roleId;
        // 論理倉庫ID
        this.logicalWhId = outputJson.users[0].logicalWhId;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    this.errorInfo = '';

    if (!this.isSubmitButtonEnabled)
      return;

    let errors = false;
    if (this.oldPasswordTx.errors !== null) {
      this.oldPasswordTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.newPasswordTx.errors !== null) {
      this.newPasswordTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.newPasswordTxConf.errors !== null) {
      this.newPasswordTxConf.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    if (this.oldPasswordTx.value === this.newPasswordTx.value) {
      this.errorInfo = '旧パスワードと新パスワードが同じです';
      return;
    }

    this.working = true;
    this.userService
      .changePassword(this.oldPasswordTx.value, this.newPasswordTx.value, 'WA9005')
      .then(outputJson => {
        this.working = false;
        this.modal = true;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  wa0001router() {
    sessionStorage.clear();
    this.router.navigate(['wa0001']);
  }

  cancel() {
    this.router.navigate([
      JSON.parse(sessionStorage.getItem('loginResult')).user.roleId === 3  
      ? 'wa0003' : 'wa0002']);
  }

  ngDoCheck() {
    this.oldPasswordCls = this.oldPasswordTx.value == '' ? '' : 'active';
    this.newPasswordCls = this.newPasswordTx.value == '' ? '' : 'active';
    this.newPasswordCls2 = this.newPasswordTxConf.value == '' ? '' : (this.newPasswordTx.value === this.newPasswordTxConf.value ? 'active' : 'error');

    this.isSubmitButtonEnabled = this.oldPasswordCls === 'active' &&
      this.newPasswordCls === 'active' &&
      this.newPasswordCls2 === 'active';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9005/wa9005.component.ts